<template>
  <el-dialog
    v-if="model"
    :title="model.id > 0 ? '编辑翻新设备' : '发布翻新设备'"
    :visible.sync="visible"
    width="560px"
    @close="$emit('update:show', false)"
    @open="opened()"
  >
    <el-form
      v-if="model"
      ref="form"
      label-width="90px"
      :model="model"
      :rules="formRules"
    >
      <el-form-item label="设备描述" prop="material_desc">
        <el-input
          placeholder="请输入请求设备描述"
          v-model="model.material_desc"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="件号" prop="material">
        <el-input placeholder="请输入件号" v-model="model.material"> </el-input>
      </el-form-item>
      <el-form-item label="维修报告" prop="report_files">
        <el-upload
          class="avatar-uploader"
          :action="fileUploadUrl"
          :limit="3"
          accept=".doc, .docx, .xls, .xlsx,.pdf"
          :headers="uploadHeader"
          :file-list="fileList"
          :on-remove="handleFileRemove"
          :on-success="handleFileSuccess"
          :on-error="handleUploadError"
          :before-upload="beforeUpload"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            最多3个文件，支持格式：.doc(x),.xls(x),.pdf，单个文件不超过10M
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item label="数量" prop="quantity">
        <el-input placeholder="" v-model="model.quantity"> </el-input>
      </el-form-item>
      <el-form-item label="序列号" prop="serial_number">
        <el-input placeholder="" v-model="model.serial_number"> </el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input placeholder="" v-model="model.remark"> </el-input>
      </el-form-item>
      <el-form-item label="单价（元）" prop="price">
        <el-input placeholder="" v-model="model.price"> </el-input>
      </el-form-item>
      <el-form-item label="图片">
        <div>
          <viewer class="viewer" ref="viewer">
            <template slot-scope="scope">
              <div
                v-for="(pic, index) in model.pics"
                :key="index"
                class="flex-row-between"
              >
                <auth-img
                  tag="el-image"
                  style="max-width: 30px; max-height: 30px"
                  :src="pic"
                  :preview-src-list="model.pics"
                />
                <el-button
                  size="mini"
                  type="text"
                  icon="el-icon-close"
                  @click="handleRemove(index)"
                  >删除</el-button
                >
              </div>
            </template>
          </viewer>
        </div>
        <el-upload
          class="avatar-uploader"
          :action="uploadUrl"
          :limit="3"
          accept="image/*"
          ref="uploader"
          :show-file-list="false"
          :headers="uploadHeader"
          :on-success="handleSuccess"
          :on-error="handleUploadError"
          :before-upload="beforeUpload"
        >
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="生产日期" prop="product_date">
        <el-input placeholder="" v-model="model.product_date"> </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submitForm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { createUsedDevice, updateUsedDevice } from '../../service/getData'
import {
  urlPerfix,
  host,
  thumbnailImagePath,
  originImagePath,
} from '@/config/env'
import store from '@/store/store'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    var checkPrice = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('价格不能为空'))
      }

      let price = parseFloat(value) || 0
      if (price <= 0) {
        callback(new Error('价格不能为0'))
      } else {
        callback()
      }
    }
    return {
      host,
      thumbnailImagePath,
      originImagePath,
      uploadUrl: urlPerfix + '/images/upload',
      fileUploadUrl: urlPerfix + '/files/upload',
      uploadHeader: { Token: store.state.userInfo.token },
      visible: this.show,
      fileList: [],
      formRules: {
        material_desc: [
          { required: true, message: '请输入请求设备描述', trigger: 'blur' },
        ],
        price: [{ validator: checkPrice, trigger: 'blur' }],
      },
      submiting: false,
    }
  },
  created() {},
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true
          this.model.price = parseFloat(this.model.price) || 0
          this.model.quantity = parseInt(this.model.quantity) || 1
          if (this.model.id > 0) {
            let res = await updateUsedDevice(this.model)
            if (res.code == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await createUsedDevice(this.model)
            if (res.code == 0) {
              this.$emit('created', res.data)
            }
          }
          this.submiting = false
          this.visible = false
        } else {
          this.submiting = false
          console.log('error submit!!')
        }
      })
    },
    opened() {
      this.fileList = this.model.report_files || []
    },
    handleSuccess(res, file) {
      if (res.code == 0) {
        this.model.pics.push(res.data)
      }
    },
    handleUploadError(err) {
      this.$message({
        message: '上传失败，请重试',
        type: 'error',
        center: true,
      })
    },
    beforeUpload(file) {
      const isLimitSize = file.size / 1024 / 1024 < this.uploadLimitSize.file
      if (!isLimitSize) {
        this.$message.error(`文件大小不能超过 ${this.uploadLimitSize.file}MB!`)
      }
      return isLimitSize
    },
    handleRemove(index) {
      this.model.pics.splice(index, 1)
    },
    handleFileRemove(index) {
      this.model.report_files.splice(index, 1)
    },
    handleFileSuccess(res, file) {
      if (res.code == 0) {
        this.model.report_files.push({
          name: file.name,
          size: file.size,
          url: res.data,
        })
      }
    },
  },
}
</script>